import { SupplierContact } from "../../../models/supplier.model"

/** Types of contacts in the contacts tab at the onboarding process */
export enum OnboardingContactType {
    MYDETAILS = 'My Details',
    PRIMARY = 'Primary',
    SALES = 'Sales',
    FINANCE = 'Finance Lead',
    REMMITANCE = 'Remit To',
    MATERIAL_PLANNING = 'Material Planning',
    CRP = 'Contractor Responsible Person',
    EHS = 'Environment, Health and Safety',
    EXTENDEDONBOARDING = 'Extended Onboarding',
    SUBTIERPROFILEADMIN = 'SubTier Profile Admin',
    SUBTIERQUALITY = 'SubTier Quality',
    SUBTIERONBOARDING = 'SubTier Onboarding',
}

/** Data of a contact tab in the tabs of contacts */
export interface OnboardingContactTabData {

    /** Which contact type is this object using */
    type: OnboardingContactType | string,

    /** Determines if the user has visited this contact tab.
     * This is used to enable tabs that the user has visited and completed,
     * so the user can go back to this tab if needed. */
    visited: boolean,

    /** Determines if we are required to create a new contact for the type */
    required: boolean,


    /** Determines if this contact is the same as the primary contact,
     * which in that case we will not create a new contact object for this type (ignoring the contact field). */
    sameAsPrimary: boolean | null,

    /** Determines if this contact is the same as current user contact,
    * which in that case we will not create a new contact object for this type (ignoring the contact field). */
    sameAsCurrentUser: boolean | null

    /** Supplier contact to save at the back-end if it's not the same as the primary contact */
    contact: SupplierContact,

    /** This flag enables the option to choose the contact as primary contact */
    displayIsPrimaryOption: boolean | null

    /** This is store assign additional contact types to the contact tab */
    additionalContactTypes: OnboardingContactType[] | []

    /** Determines if this contact is copied from an exsiting contact */
     isContactCopied: boolean | null
}

/**
 * Collection of contacts for each contact type to create all contacts at the end of the contacts tab of onboarding
 */
export interface ContactGroupModel {
    [type: string]: OnboardingContactTabData
}
